<template>
  <div class="qmyx-container">
    <div class="toast" v-if="isShowToast">
      {{ toast }}
    </div>
    <div class="shadow-bg" v-if="isShowShadow">
      <div class="shadow-box">
        <span class="shadow-box-title">提示</span>
        <span class="shadow-box-text"
          >手机号码不存在，请先下载华发优生活App并注册账号</span
        >
        <div class="shadow-box-btn-wrap">
          <div class="shadow-box-btn-cancel" @click="handleCancel()">忽略</div>
          <div class="shadow-box-btn-go" @click="handleGo()">前往</div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="header">
        {{ "我的积分：" + myScore }}
      </div>
      <div class="body-inputArea body-inputArea-input">
        {{ phoneNum }}
      </div>
      <div class="body-inputArea">
        <input
          class="body-inputArea-input width"
          tpye="number"
          :maxlength="10"
          placeholder="请输入本次兑换的积分"
          v-model.number="inputScore"
        />
        <div class="body-inputArea-flex">
          <span class="body-inputArea-coin">{{ coin }}</span>
          <span class="body-inputArea-text">优币</span>
        </div>
      </div>
      <div class="body-explain">
        1、积分须为100的倍数，且大于0；
      </div>
      <div class="body-explain">
        2、全民营销积分兑换优币比率为100：1
      </div>
      <button
        class="body-button"
        :class="enableBtnClass"
        :disabled="!isReady"
        type="button"
        @click="sendData"
      >
        确认
      </button>
    </div>
  </div>
</template>
<script>
import { postScore } from "./api";
import { getScore } from "./api";
import { getAgent } from "@/views/qmyx/api";

export default {
  data() {
    return {
      myScore: 0,
      phoneNum: "",
      inputScore: undefined,
      isShowToast: false,
      isShowShadow: false,
      timer: null,
      toast: "积分须为100的倍数,请重新输入",
      sending: false
    };
  },
  computed: {
    coin() {
      if (this.inputScore == "" || this.inputScore == undefined) {
        return "- -";
      }
      if (this.inputScore >= 100 && this.inputScore <= this.myScore) {
        return Math.floor(this.inputScore / 100);
      }
      if (this.inputScore > this.myScore) {
        return Math.floor(this.myScore / 100);
      }
      return 0;
    },
    enableBtnClass() {
      return this.isReady ? "ready" : "not-ready";
    },
    isReady() {
      return (
        this.inputScore &&
        this.inputScore % 100 === 0 &&
        this.inputScore <= this.myScore &&
        this.inputScore > 0 &&
        !this.sending
      );
    }
  },
  watch: {
    isShowToast(val) {
      this.stopTimer();
      if (val) {
        this.timer = setTimeout(this.hideToast, 2500);
      }
    }
  },
  activated() {
    this.intiPage();
    this.loadData();
  },
  methods: {
    intiPage() {
      this.inputScore = undefined;
      this.isShowToast = false;
      this.hideShoadow();
    },
    async loadData() {
      let res = await getAgent();
      const {
        agentLogin: { id = "", agentTel = "" }
      } = res;
      this.phoneNum = agentTel;
      let params = { agentId: id };
      const { data } = await getScore(params);
      this.computedScore(data);
    },
    async sendData() {
      if (this.isReady) {
        let params = {
          agentTel: this.phoneNum,
          integration: this.inputScore
        };
        this.sending = true;
        try {
          const res = await postScore(params);
          if (res.code === 1) {
            this.showShadow();
          } else if (res.code === 0) {
            this.navigateTo("exchange-succeed");
          }
        } catch {
          console.log("网络异常");
          this.showToast("与服务器连接异常");
          this.sending = false;
        }
      } else {
        if (this.inputScore % 100 != 0) {
          this.showToast("积分须为100的倍数,请重新输入");
        } else if (this.inputScore > this.myScore) {
          const txt = "目前可兑换积分为" + this.myScore;
          this.showToast(txt);
        }
      }
    },
    computedScore(res) {
      let totalScore = 0;
      for (var i = 0; i < res.length; i++) {
        totalScore += Number(res[i].surplusPoints);
      }
      this.myScore = totalScore;
    },
    navigateTo(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    showToast: function(str) {
      this.toast = str;
      this.isShowToast = true;
    },
    stopTimer() {
      this.timer && clearTimeout(this.timer);
      this.timer = null;
    },
    hideToast: function() {
      this.isShowToast = false;
    },
    showShadow() {
      this.isShowShadow = true;
    },
    hideShoadow() {
      this.sending = false;
      this.isShowShadow = false;
    },
    handleGo() {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.huafa.ulife";
    },
    handleCancel() {
      this.hideShoadow();
    }
  }
};
</script>

<style lang="scss">
.shadow-bg {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #000000;
  background: rgba(0, 0, 0, 0.5);
}
.shadow-box {
  position: absolute;
  top: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 6.36rem;
  height: 3.86rem;
  background: white;
  border-radius: 0.16rem;
}
.shadow-box-text {
  text-align: center;
  padding: 0.56rem 0.84rem;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 0.36rem;
  border-bottom: 0.02rem solid #cccccc;
  line-height: 0.5rem;
}
.shadow-box-title {
  margin-top: 0.32rem;
  font-weight: 600;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 0.4rem;
}
.shadow-box-btn-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
}
.shadow-box-btn-cancel {
  color: #999999;
  font-size: 0.36rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
  border-right: 0.02rem solid #cccccc;
}
.shadow-box-btn-go {
  color: #f07b24;
  font-size: 0.36rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
}
.toast {
  background: black;
  color: white;
  text-align: center;
  padding: 0.46rem 0.32rem 0.46rem 0.32rem;
  width: 60%;
  line-height: 0.34rem;
  opacity: 0.7;
  border-radius: 0.1rem;
  position: fixed;
  left: 15%;
  top: 30%;
}
.body {
  padding: 0 0.32rem;
}
.header {
  font-weight: Regular;
  padding: 0.4rem 0 0.3rem 0;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, sans-serif;
}
.body-inputArea {
  display: flex;
  padding: 0.4rem 0 0.3rem 0;
  border-bottom: 0.02rem solid rgba(221, 221, 221, 1);
  justify-content: space-between;
  align-items: center;
}
.body-inputArea-flex {
  display: flex;
  flex-wrap: nowrap;
}
.body-inputArea-input {
  font-weight: Medium;
  font-family: PingFangSC-Medium, sans-serif;
  color: #333333;
  font-size: 0.28rem;
}
.width {
  width: 60%;
}
.body-inputArea-coin {
  float: right;
  margin-right: 0.12rem;
  font-size: 0.32rem;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
  color: #333333;
}
.body-inputArea-text {
  float: right;
  color: #999999;
  font-size: 0.3rem;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
  flex: 1;
}
.body-explain {
  padding-top: 0.28rem;
  color: #999999;
  font-size: 0.24rem;
  font-weight: Regular;
  font-family: PingFangSC-Regular, sans-serif;
}
.ready {
  background: rgba(240, 123, 36, 1);
}
.not-ready {
  background: rgba(240, 123, 36, 0.42);
  pointer-events: none;
}
.body-button {
  margin-top: 0.74rem;
  width: 100%;
  height: 1rem;
  color: white;
  font-size: 0.32rem;
  border-radius: 0.1rem;
  font-weight: Medium;
  font-family: PingFangSC-Medium, sans-serif;
}
</style>
